import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=531eaa1c"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=531eaa1c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/74a6e498-56df-5c0c-aa3e-2f5fe39d1378/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531eaa1c')) {
      api.createRecord('531eaa1c', component.options)
    } else {
      api.reload('531eaa1c', component.options)
    }
    module.hot.accept("./AuthLayout.vue?vue&type=template&id=531eaa1c", function () {
      api.rerender('531eaa1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Pages/AuthLayout.vue"
export default component.exports